import { Pagination, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { cutContainersSchema } from 'global/schemas/cargomateSchema'
import fileDownload from 'js-file-download'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import './cutContainerTable.less'

const DEFAULT_PAGE_SIZE = 10

export const exportCutContainers = containers => {
  const csv = [
    ['Position', 'Container number'],
    ...containers.map(({ position, container }) => [
      // Force Excel to treat the position as text so leading zeros
      // (e.g. "0001245") are not stripped when the CSV is opened.
      `="${String(position || '')}"`,
      container,
    ]),
  ]
    .map(row =>
      row
        .map(value => `"${String(value || '').replaceAll('"', '""')}"`)
        .join(',')
    )
    .join('\n')

  fileDownload(csv, 'cut-containers.csv', 'text/csv;charset=utf-8')
}

const CutContainerTable = ({ containers, isLoading, searchTerm }) => {
  const { t } = useTranslation()
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    setCurrentPage(1)
  }, [searchTerm])

  const parsedContainers = cutContainersSchema.safeParse(containers)
  const dataSource = parsedContainers.success ? parsedContainers.data : []
  const normalizedSearchTerm = searchTerm.trim().toLowerCase()
  const filteredContainers = dataSource.filter(
    container =>
      !normalizedSearchTerm ||
      String(container.position || '')
        .toLowerCase()
        .includes(normalizedSearchTerm) ||
      String(container.container || '')
        .toLowerCase()
        .includes(normalizedSearchTerm)
  )
  const paginatedContainers = filteredContainers.slice(
    (currentPage - 1) * DEFAULT_PAGE_SIZE,
    currentPage * DEFAULT_PAGE_SIZE
  )

  const columns = [
    {
      dataIndex: 'position',
      key: 'position',
      sorter: (left, right) =>
        String(left.position || '').localeCompare(String(right.position || '')),
      title: 'Position',
    },
    {
      dataIndex: 'container',
      key: 'container',
      sorter: (left, right) =>
        String(left.container || '').localeCompare(
          String(right.container || '')
        ),
      title: 'Container number',
    },
  ]

  return (
    <>
      <Table
        columns={columns}
        dataSource={paginatedContainers}
        loading={isLoading}
        pagination={false}
        rowKey={(container, index) =>
          container.id || container.container || index
        }
      />
      <div className="cut-container-table__footer">
        <span className="cut-container-table__total-label">
          {t('portCall.cutContainerTotalLabel', {
            count: dataSource.length,
          })}
        </span>
        <Pagination
          className="cut-container-table__pagination"
          current={currentPage}
          onChange={setCurrentPage}
          pageSize={DEFAULT_PAGE_SIZE}
          showSizeChanger={false}
          showTitle={false}
          total={filteredContainers.length}
        />
      </div>
    </>
  )
}

CutContainerTable.defaultProps = {
  containers: [],
  isLoading: false,
  searchTerm: '',
}

CutContainerTable.propTypes = {
  containers: PropTypes.arrayOf(
    PropTypes.shape({
      container: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      position: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  isLoading: PropTypes.bool,
  searchTerm: PropTypes.string,
}

export default CutContainerTable
